import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class ScrollToTop extends Component {
  static propTypes = {
    pathname: PropTypes.string.isRequired,
  };

  componentDidUpdate(prevProps) {
    const { pathname } = this.props;
    if (pathname !== prevProps.pathname) {
      if (
        pathname &&
        prevProps.pathname &&
        (
          (pathname.indexOf('team') > -1 &&
            prevProps.pathname.indexOf('team') > -1) ||
            (pathname.indexOf('careers/') > -1 &&
            prevProps.pathname.indexOf('team') > -1) ||
            (pathname.indexOf('team') > -1 &&
            prevProps.pathname.indexOf('careers/') > -1)
        )
      ) {
        return;
      }
      window.scrollTo(0, 0);
    }
  }

  render() {
    return null;
  }
}

const mapStateToProps = state => {
  const { pathname } = state.router.location;
  return {
    pathname,
  };
};

export default connect(mapStateToProps, null)(ScrollToTop);



// WEBPACK FOOTER //
// ./src/modules/core/components/ScrollToTop.js